import Actions from '../Collection/actions'

const actions = Actions.get('PARTNERS_');

export default actions;
